import PropTypes from 'prop-types'
import React from 'react'
import InputElement from 'react-input-mask'

const BuyDateInput = ({
  dataCy,
  name,
  label,
  placeholder,
  tooltip,
  update,
  classes,
  labelStyle,
  isSymbol,
  theSymbol,
  defaultValue,
  mask = '99/99/9999',
  maskChar = '_',
}) => {
  const tip = _tooltip =>
    _tooltip ? (
      <div className="help-label left">
        <span className="help-tip" key={'tip'}>
          {_tooltip}
        </span>
      </div>
    ) : null

  return (
    <div className={isSymbol}>
      <InputElement
        className={classes}
        data-cy={dataCy}
        data-hj-suppress
        defaultValue={defaultValue}
        inputMode="numeric"
        key="input"
        mask={mask}
        maskChar={maskChar}
        name={name}
        onBlur={update}
        pattern="[0-9]*"
        placeholder={placeholder}
        type="text"
      />
      <label className="label" key={'label'} style={labelStyle}>
        {label}
      </label>
      <span className="symbol">{theSymbol}</span>
      {tip(tooltip)}
    </div>
  )
}

BuyDateInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  dataCy: PropTypes.string,
  update: PropTypes.func.isRequired,
  tooltip: PropTypes.array,
  mask: PropTypes.string,
  maskChar: PropTypes.string,
}

export default BuyDateInput
